// material-ui
// import { useTheme } from '@mui/material/styles';
import logo from '../assets/images/auth/logopng.png'
// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    // const theme = useTheme();

    return (
        <img
            src={logo}
            alt='logo'
            width={'auto'}
            height={'50px'}
        />
    );
};

export default Logo;
